const BuyButtons = ({ data }) => {
  function mapDataToArray(data) {
    try {
      return Object.keys(data).map((key) => data[key]);
    } catch (error) {
      console.error("An error occurred while mapping data:", error);
      return [];
    }
  }

  const buttons = mapDataToArray(data);
  // const Benue = mapDataToArray(benue);
  // const Abuja = mapDataToArray(abuja);
  // const Jos = mapDataToArray(jos);

  return (
    <div className="flex w-full mx-auto py-8 space-y-0 gap-4 justify-center items-center md:py-16">
      <h2 className="text-xl font-bold text-gray-800 md:text-3xl">
        Order Now!
      </h2>
      {/* Online Btns */}
      <div className="flex mx-auto justify-end items-center space-x-2">
        {buttons.map((btn, index) => (
          <a
            key={index}
            href={btn.link}
            style={{
              borderColor: btn.color,
              borderStyle: "solid",
              borderWidth: "2px",
            }}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-orange-50 rounded-lg p-2 px-3 transition-transform hover:duration-300 hover:transform hover:translate-y-1"
          >
            <img
              src={btn.image.asset.url}
              alt={btn.alt}
              className="w-12 h-4 md:w-32 md:h-12"
            />
          </a>
        ))}
      </div>
      {/* Physical Stores */}
      {/* <div className="w-full flex flex-col mx-auto p-2 justify-between items-center space-y-2 md:flex-row md:space-y-0 md:space-x-2"> */}
      {/* Benue */}
      {/* <div className="flex mx-auto justify-between items-center space-x-2 p-2">
          <span className="bg-[#EBEBE8] text-[#47C0DB] p-2 text-sm font-normal leading-normal border border-[#47C0DB] rounded-[15px]">
            <span className="text-[10px]">NG</span> Benue
          </span>
          {Benue.map((btn, index) => (
            <a
              key={index}
              href={btn.link}
              style={{
                borderColor: btn.color,
                borderStyle: "solid",
                borderWidth: "2px",
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg p-2 px-3 transition-transform hover:duration-300 hover:transform hover:translate-y-1"
            >
              <img
                src={btn.image.asset.url}
                alt={btn.alt}
                className="w-10 h-3 md:w-20 md:h-6"
              />
            </a>
          ))}
        </div> */}
      {/* ABuja */}
      {/* <div className="flex mx-auto justify-between items-center space-x-2 p-2">
          <span className="bg-[#EBEBE8] text-[#47C0DB] p-2 text-sm font-normal leading-normal border border-[#47C0DB] rounded-[15px]">
            <span className="text-[10px]">NG</span> Abuja
          </span>
          {Abuja.map((btn, index) => (
            <a
              key={index}
              href={btn.link}
              style={{
                borderColor: btn.color,
                borderStyle: "solid",
                borderWidth: "2px",
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg p-2 px-3 transition-transform hover:duration-300 hover:transform hover:translate-y-1"
            >
              <img
                src={btn.image.asset.url}
                alt={btn.alt}
                className="w-10 h-3 md:w-20 md:h-6"
              />
            </a>
          ))}
        </div> */}
      {/* Jos */}
      {/* <div className="flex mx-auto justify-between items-center space-x-2 p-2">
          <span className="bg-[#EBEBE8] text-[#47C0DB] p-2 text-sm font-normal leading-normal border border-[#47C0DB] rounded-[15px]">
            <span className="text-[10px]">NG</span> Jos
          </span>
          {Jos.map((btn, index) => (
            <a
              key={index}
              href={btn.link}
              style={{
                borderColor: btn.color,
                borderStyle: "solid",
                borderWidth: "2px",
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-lg p-2 px-3 transition-transform hover:duration-300 hover:transform hover:translate-y-1"
            >
              <img
                src={btn.image.asset.url}
                alt={btn.alt}
                className="w-10 h-3 md:w-20 md:h-6"
              />
            </a>
          ))}
        </div> */}
      {/* </div> */}
    </div>
  );
};

export default BuyButtons;
